
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import RequestLogsForm from '@/services/WebsiteLog/forms/RequestLogsForm';

@Component({
  mixins: [Themeable],
})
export default class LogsDialog extends Vue {
  @Prop() public domain!: string;

  public visible: boolean = true;

  public form: WPXFormValue<RequestLogsForm> = new WPXFormValue(RequestLogsForm);

  public logTypes: string[] = ['access', 'error'];

  public logLines: number[] = [10, 20, 50];

  public showLogs(): void {
    this.$emit('showLogs', { type: this.form.data.type, lines: this.form.data.lines });
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
